import { Button, ButtonProps, HStack, VStack } from '@chakra-ui/react';
import { Image, ImageMap } from '@common/components/Image';
import { FontFamily } from '@common/theming/Fonts';
import * as React from 'react';
import { Link } from 'react-router-dom';
import { TextBlock } from '../components/TextBlock';

interface SidebarSubmenuItemProps extends ButtonProps {
  route: string;
  label: string;
  description?: string;
  tag?: string;
  image?: keyof typeof ImageMap;
}

export const SidebarSubmenuItem = (props: SidebarSubmenuItemProps) => {
  const { route, label, tag, description, image, ...buttonProps } = props;
  const isCurrentRoute = route ? window.location.pathname === route : false;
  const labelFontSize = 16;
  const descriptionFontSize = 10;

  return (
    <Button
      as={Link}
      to={route}
      height={'auto'}
      variant="ghost"
      justifyContent="start"
      colorScheme="black"
      fontWeight="normal"
      flexDirection={'column'}
      position="relative"
      pl="50px"
      py="10px"
      {...buttonProps}>
      <div
        style={{
          borderBottom: isCurrentRoute ? '2px solid #000000' : '2px solid #e2e2e2',
          borderBottomLeftRadius: '8px',
          borderLeft: isCurrentRoute ? '2px solid #000000' : '2px solid #e2e2e2',
          height: '500px',
          left: '16px',
          marginBottom: '20px',
          marginLeft: '7px',
          marginTop: '-490px',
          position: 'absolute',
          width: '20px',
          zIndex: isCurrentRoute ? 2 : 1,
        }}></div>

      <VStack alignItems={'flex-start'} maxW={'200px'} whiteSpace={'break-spaces'} textAlign={'left'}>
        <HStack>
          {image && (
            <Image
              image={image}
              boxSize={'17px'}
              filter={isCurrentRoute ? 'none' : 'grayscale(1)'}
              opacity={isCurrentRoute ? 1 : 0.5}
            />
          )}
          <TextBlock weight={isCurrentRoute ? 'bold' : 'normal'} fontSize={`${labelFontSize}px`}>
            {label}
          </TextBlock>
          {tag && (
            <TextBlock
              as="span"
              backgroundColor={'black'}
              color="white"
              weight="bold"
              fontSize={'8px'}
              lineHeight={'8px'}
              padding="4px 4px 2px"
              borderRadius={'4px'}>
              {tag}
            </TextBlock>
          )}
        </HStack>
        {description && (
          <TextBlock as="span" color="gray.300" fontSize={`${descriptionFontSize}px`} lineHeight={'10px'} weight="bold">
            {description}
          </TextBlock>
        )}
      </VStack>
    </Button>
  );
};
